export { default } from './login-page'
